<template>
  <div :class="[$style.findWrap]">
    <h1 :class="[$style.findTitle]">{{ $t('account_form.find_pw') }}</h1>
    <form :class="[$style.inputForm]">
      <el-input
        :class="[$style.inputFind]"
        :placeholder="$t('account_form.email_place')"
      />
      <el-input
        :class="[$style.inputFind]"
        :placeholder="$t('account_form.code_place')"
      />
      <el-input
        :class="[$style.inputFind]"
        :placeholder="$t('myprofile.new_pw')"
        type="password"
      />
      <el-input
        :class="[$style.inputFind]"
        :placeholder="$t('account_form.confirm_pw')"
        type="password"
      />
      <button :class="[$style.findButton]">{{ $t('confirm') }}</button>
    </form>
  </div>
</template>
<script>
export default {
  methods: {},
}
</script>

<style lang="scss" module>
@import '@design';

.findWrap {
  box-sizing: border-box;
  max-width: 500px;
  margin: 0 auto;
  margin-top: 100px;
  margin-bottom: 100px;
  border: 1px solid #bbbfc7;
}
.findTitle {
  height: 50px;
  margin: 0;
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 50px;
  color: #fff;
  text-align: center;
  background: #63bc90;
}
.inputForm {
  padding: 20px;
}
.inputFind {
  display: block;
  width: 100%;
  height: 40px;
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 40px;
  border-radius: 3px;
  transition: box-shadow 0.1s ease, -webkit-box-shadow 0.1s ease;
}
.findLink {
  margin-right: 10px;
  margin-bottom: 30px;
  cursor: pointer;
}
.findButton {
  width: 100%;
  height: 40px;
  margin: 10px 0;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(75deg, #65aa88, #65aa88 50%, #7cc0d3 100%);
  border: 1px solid #b5b5b6;
  border-radius: 20px;
}
.findButton:hover {
  background-color: #9354ac;
  border-color: #9354ac;
}
</style>
